<template>
  <v-dialog
    v-model="dialog"
    width="auto"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card class="p-0 m-0">
      <QuoteForm
        :dialog="dialog"
        :clone="clone"
        :clientId="clientId"
        :item="item"
        :hideTitle="true"
        @onCancel="closeDelete()"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import QuoteForm from "./Form";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    QuoteForm,
  },
  props: {
    clone:Boolean,
    clientId: Number,
    item: Object,
    show: [Boolean, String],
  },
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
    }),
  },
  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },
    dialog(n, o) {
      if (!n && o) {
        this.closeDelete();
      } else {
        this.onDialogOpen();
      }
      this.$store.dispatch('alert/clear');
    },
  },
  methods: {
    ...mapActions("account", ["delete"]),
    closeDelete() {
      this.dialog = false;
      this.$emit("onClosed");
    },

    onDialogOpen() {
      console.log('refs', this.$refs);
    },

    async deleteItemConfirm() {
      this.loading = true;
      await this.delete(this.item);
      if (!this.account.status.error) {
        this.closeDelete();
        this.$emit("onSucceded");
      }
      this.loading = false;
    },
  },
};
</script>